import {updatePrimaryBeneficiaryValues} from 'ApplicationEntry/ducks/primaryBeneficiary';
import {removePrimaryBeneficiary} from 'ApplicationEntry/ducks/primaryBeneficiaryList';
import {ApplicationModeType} from 'ApplicationEntry/models/ApplicationModeType';
import {PrimaryBeneficiaryList} from 'ApplicationEntry/models/PrimaryBeneficiaryList';
import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import ActionsMenu from 'Shared/components/PagedView/ActionsMenu';
import {maskPhoneNumber} from 'Shared/utilities/phoneNumberMasker';
import {maskTaxId} from 'Shared/utilities/taxIdMasker';
import './PrimaryBeneficiary.sass';
import PrimaryBeneficiaryDialog from './PrimaryBeneficiaryDialog';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import DateUtility from 'Shared/utilities/DateUtility';
import {maskZipCode} from 'ApplicationEntry/models/ZipCode';

type TabularProps = {
  primaryBeneficiaryItem: PrimaryBeneficiaryList;
  mode: ApplicationModeType;
};

export default function PrimaryBeneficiaryTabularList(props: TabularProps) {
  const dispatch = useDispatch();

  const [openDeleteBox, setOpenDeleteBox] = useState(false);
  const [Index, setIndex] = useState(0);
  const [openEditBox, setOpenEditBox] = useState(false);

  const handleClickOpen = (index: number) => {
    setOpenDeleteBox(true);
    setIndex(index);
  };

  const handleEditPrimaryBeneficiary = (index: number) => {
    setIndex(index);
    const primaryBeneficiaryItems = props.primaryBeneficiaryItem.primaryBeneficiaryList.toArray()[index];

    dispatch(
      updatePrimaryBeneficiaryValues(
        primaryBeneficiaryItems.firstName,
        primaryBeneficiaryItems.middleName,
        primaryBeneficiaryItems.lastName,
        primaryBeneficiaryItems.relationship,
        primaryBeneficiaryItems.percent,
        maskTaxId(primaryBeneficiaryItems.socialSecurityNumber.value),
        primaryBeneficiaryItems.dob,
        primaryBeneficiaryItems.phone,
        primaryBeneficiaryItems.address,
        primaryBeneficiaryItems.addressLine2,
        primaryBeneficiaryItems.city,
        primaryBeneficiaryItems.state,
        primaryBeneficiaryItems.zip,
        primaryBeneficiaryItems.occSmokerCode,
        primaryBeneficiaryItems.signatureDate,
      )
    );
    setOpenEditBox(true);
  };

  const handleClose = () => {
    setOpenDeleteBox(false);
    setOpenEditBox(false);
  };

  const isQuality = props.mode === ApplicationModeType.Quality;

  return (
    <>
      <TableContainer component={Paper}>
        <Table className="primary-beneficiary-section__table">
          <TableHead>
            <TableRow>
              <TableCell>First Name</TableCell>
              <TableCell>Middle Name</TableCell>
              <TableCell>Last Name</TableCell>
              <TableCell>Percent</TableCell>
              <TableCell>SSN</TableCell>
              <TableCell>Relationship</TableCell>
              <TableCell>Address</TableCell>
              <TableCell>Address 2</TableCell>
              <TableCell>City</TableCell>
              <TableCell>State</TableCell>
              <TableCell>Zip</TableCell>
              <TableCell>Phone</TableCell>
              <TableCell>DOB</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props.primaryBeneficiaryItem.primaryBeneficiaryList.map((item, index) => {
              return (
                <TableRow key={index}>
                  <TableCell component="th" scope="row">
                    {item.firstName.value}
                  </TableCell>
                  <TableCell>{item.middleName.value}</TableCell>
                  <TableCell>{item.lastName.value}</TableCell>
                  <TableCell>{item.percent}%</TableCell>
                  <TableCell>{maskTaxId(item.socialSecurityNumber.value)}</TableCell>
                  <TableCell>{item.relationship.value}</TableCell>
                  <TableCell>{item.address.value}</TableCell>
                  <TableCell>{item.addressLine2.value}</TableCell>
                  <TableCell>{item.city.value}</TableCell>
                  <TableCell>{item.state.value}</TableCell>
                  <TableCell>{maskZipCode(item.zip.value)}</TableCell>
                  <TableCell>{maskPhoneNumber(item.phone.phoneNumber)}</TableCell>
                  <TableCell>{DateUtility.toFormattedDate(item.dob)}</TableCell>
                  <TableCell>
                    <ActionsMenu>
                      <MenuItem key="primary-beneficiary-edit" onClick={() => handleEditPrimaryBeneficiary(index)}>
                        Edit
                      </MenuItem>
                      <MenuItem key="primary-beneficiary-delete" onClick={() => handleClickOpen(index)}>
                        Delete
                      </MenuItem>
                    </ActionsMenu>
                  </TableCell>
                </TableRow>
              );
            })}
            <TableRow>
              <TableCell className="primary-beneficiary-section__table-total-count">Item Count:</TableCell>
              <TableCell className="primary-beneficiary-section__table-total-count">
                {props.primaryBeneficiaryItem.primaryBeneficiaryList.size}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      {props.primaryBeneficiaryItem.primaryBeneficiaryList.size > 0 ? (
        <Dialog
          open={openDeleteBox}
          keepMounted
          onClose={handleClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle id="alert-dialog-slide-title" color="primary" style={{color: 'red'}}>
            Delete Primary Beneficiary
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              Primary Beneficiary will be removed from the list. Do you want to delete{' '}
              <span style={{fontWeight: 'bold'}}>
                {props.primaryBeneficiaryItem.primaryBeneficiaryList.toArray()[Index].firstName.value}{' '}
                {props.primaryBeneficiaryItem.primaryBeneficiaryList.toArray()[Index].lastName.value}?
              </span>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancel
            </Button>
            <Button
              onClick={() => {
                setOpenDeleteBox(false);
                setIndex(0);
                dispatch(removePrimaryBeneficiary(Index));
              }}
              color="primary"
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      ) : null}
      <PrimaryBeneficiaryDialog
        dialogOpen={openEditBox}
        dialogClose={handleClose}
        dialogTitle="Add Primary Beneficiary(s)"
        dialogSubTitle="Beneficiary(s) Information"
        dialogAdditional="ADDITIONAL BENEFICIARY"
        primaryBeneficiaryIndex={Index}
        editPrimaryBeneficiary={openEditBox}
      />
    </>
  );
}
